import { cn } from '@/lib/utils';

/**
 * Google Ads Quality Score pill (1-10, from ad_group_criterion.quality_info).
 * Bands match the team's report convention: 1-3 red (action needed), 4-6 amber
 * (could improve), 7-10 green (healthy). Null renders an em-dash placeholder —
 * QS only exists for keywords with enough recent impressions.
 *
 * Extracted from performance-v2 (#5847) so the ad Keywords tab and any future
 * quality surfaces share one banding.
 */
export function QualityScorePill({ score }: { score: number | null | undefined }) {
  if (score == null) return <span className="text-xs text-gray-400">—</span>;
  const cls =
    score <= 3 ? 'bg-red-100 text-red-700' :
    score <= 6 ? 'bg-amber-100 text-amber-800' :
    'bg-green-100 text-green-800';
  return (
    <span className={cn('inline-flex items-center justify-center w-7 h-5 rounded-full text-xs font-semibold', cls)}>
      {score}
    </span>
  );
}
